import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { CustomStore, BreezeDxStoreService, AuthService, GenesisUnitOfWork, MessageService } from 'app/core/core.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { EntityQuery } from 'breeze-client';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute } from '@angular/router';
import { confirm, alert } from 'devextreme/ui/dialog';
import _ from 'lodash';
import { Subscription } from 'rxjs';
import { CustomerAddDialogComponent } from 'app/shared/customer-add-dialog/customer-add-dialog.component';
import { SharedModule } from 'app/shared/shared.module';

@Component({
    selector: 'app-customer-search',
    templateUrl: './customer-search.component.html',
    styleUrls: ['./customer-search.component.scss'],
    standalone: false
})
export class CustomerSearchComponent implements OnInit {
    customers: any;
    workOrderList: any[];
    showAllOrders = false;
    filter: any;

    salesMode = false;
    ordersMode = false;
    claimButtonDisable = true;
    unclaimButtonDisable = true;
    woAddedSubscription: Subscription;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(
        private uow: GenesisUnitOfWork,
        private router: Router,
        private storeService: BreezeDxStoreService,
        private auth: AuthService,
        private modalService: BsModalService,
        private messageService: MessageService,
        private route: ActivatedRoute
    ) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.customers = await this.uow.getCustomers();
        console.log(this.customers);
    }

    search() {}
    clear() {}

    selectionChange(e) {}

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            }
        );
    }

    async open(customerId: number) {
        let customer = null;
        if (!!customerId) {
            customer = await this.uow.customers.byId(customerId);
        }
        const modalRef = this.modalService.show(CustomerAddDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                customer: customer,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.result) {
                this.getData();
            }
            modalRef.hide();
        });
    }

    // async open(customerId: number) {
    //     this.router.navigate(['/customers/' + (!!customerId ? customerId : 'new')]);
    // }
}
